import { typedAction } from '../helpers'
import { AppState, OraclePrices, WindowSize } from '../../types'
import produce from 'immer'
import { RootState } from '..'

const initialState: AppState = {
  screen: {
    windowHeight: 0,
    windowWidth: 0,
  },
  oraclePrices: {
    SOL_USD: null,
    BANANA_USD: null,
    KONG_USD: null,
    timer: null,
  },
  tab: 0,
}

// DISPATCHES
export const setScreen = (screen: WindowSize) => {
  return typedAction('app/SET_SCREEN', {
    screen: screen,
  })
}

export const setArbTransactionSignature = (
  arbTransactionSignature?: string
) => {
  return typedAction('app/SET_ARB_TRANSACTION_SIGNATURE', {
    arbTransactionSignature: arbTransactionSignature,
  })
}

export const setOraclePrices = (price: OraclePrices) => {
  return typedAction('app/SET_ORACLE_PRICES', {
    SOL_USD: price.SOL_USD,
    BANANA_USD: price.BANANA_USD,
    KONG_USD: price.KONG_USD,
  })
}

export const setOracleTimer = (oracleTimer: NodeJS.Timer | null) => {
  return typedAction('app/SET_ORACLE_TIMER', {
    oracleTimer: oracleTimer,
  })
}

export const setTab = (tab: number) => {
  return typedAction('app/SET_TAB', {
    tab: tab,
  })
}

type AppStateAction = ReturnType<
  | typeof setScreen
  | typeof setArbTransactionSignature
  | typeof setOraclePrices
  | typeof setOracleTimer
  | typeof setTab
>

// REDUCER
export function appReducer(
  state: AppState = initialState,
  action: AppStateAction
): AppState {
  switch (action.type) {
    case 'app/SET_SCREEN':
      return produce(state, (draftState: AppState) => {
        draftState.screen = action.payload.screen
      })
    case 'app/SET_ARB_TRANSACTION_SIGNATURE':
      return produce(state, (draftState: AppState) => {
        draftState.arbTransactionSignature =
          action.payload.arbTransactionSignature
      })
    case 'app/SET_TAB':
      return produce(state, (draftState: AppState) => {
        draftState.tab = action.payload.tab
      })
    case 'app/SET_ORACLE_PRICES':
      return produce(state, (draftState: AppState) => {
        draftState.oraclePrices.SOL_USD = action.payload.SOL_USD
        draftState.oraclePrices.BANANA_USD = action.payload.BANANA_USD
        draftState.oraclePrices.KONG_USD = action.payload.KONG_USD
      })
    case 'app/SET_ORACLE_TIMER':
      return produce(state, (draftState: AppState) => {
        if (draftState.oraclePrices.timer) {
          clearInterval(draftState.oraclePrices.timer)
        }
        draftState.oraclePrices.timer = action.payload.oracleTimer
      })
    default:
      return state
  }
}

// SELECTORS
export const getScreen = (state: RootState) => state.app.screen
export const getArbTransactionSignature = (state: RootState) =>
  state.app.arbTransactionSignature
export const getSelectedTab = (state: RootState) => state.app.tab
export const getOraclePrices = (state: RootState) => state.app.oraclePrices
